// Imported FIRST by a project's web/main.tsx (ADR 0016): before any other module runs, the page's CSP
// nonce (the `<meta property="csp-nonce">` the app's backend fills per response) is given to the code
// that inserts <style> elements at run time — react-remove-scroll behind Radix dialogs reads
// `__webpack_nonce__`, sonner and others create style elements. `style-src` admits only 'self' and the
// nonce; <style> in injected markup (innerHTML) never gets it, so it stays blocked.
const nonceOf = (doc: Document) => {
  const meta = doc.querySelector<HTMLMetaElement>('meta[property=csp-nonce]');
  return meta?.nonce || meta?.getAttribute('nonce') || undefined;
};

const nonce = nonceOf(document);
if (nonce) {
  (window as unknown as { __webpack_nonce__?: string }).__webpack_nonce__ = nonce;
  const proto = Object.getPrototypeOf(document) as Document;
  const create = proto.createElement;
  if (!(create as { cortexNonce?: boolean }).cortexNonce) {
    const stamped = function (this: Document, tag: string, options?: ElementCreationOptions) {
      const el = create.call(this, tag, options);
      if (el instanceof HTMLStyleElement && !el.nonce) el.nonce = nonce;
      return el;
    } as typeof create;
    (stamped as { cortexNonce?: boolean }).cortexNonce = true;
    proto.createElement = stamped;
  }
}
export {};
